export const supportNewTransferStationPageXenv = [
    'hwfastapp',
    'alimp',
    'wxmp'
];
